<template>
  <div class="contact_us">
    <div class="con_nav">
      <nav-tab :nav-data="navData" />
    </div>
    <div class="con_center">
      <HowItem />
    </div>
    <div class="con_bottom">
      <layout-bottom />
    </div>
  </div>
</template>

<script>
import NavTab from '@/components/NavTab'
import HowItem from '@/components/howItWorks/howItem'
import LayoutBottom from '@/components/LayoutBottom'
export default {
  components: {
    NavTab,
    HowItem,
    LayoutBottom
  },
  data() {
    return {
      navData: {
        index: 3,
        list: [
          {
            name: 'HOME',
            link: '/'
          },
          {
            name: 'SMART CREDIT SCORE',
            link: '/loan'
          },
          {
            name: 'ABOUT US',
            link: '/about_us'
          },
          {
            name: 'HOW IT WORKS',
            link: '/how_it_works'
          },
          {
            name: 'Preguntas frecuentes',
            link: '/faq'
          },
          {
            name: 'CONTACT US',
            link: '/contact_us'
          }]
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px){
  .con_center{
    padding-top: 60px;
  }
}
@media only screen and (max-width: 767px){}

</style>
